module.exports = __webpack_public_path__ + "static/media/slider1.01a2497b.png";